import Vue from 'vue'
import VueRouter from 'vue-router'
import BoardView from '../views/BoardView'
import NotFound from '../views/NotFound'

Vue.use(VueRouter);

const routes = [
  {
    path: '/public/board/:boardId',
    name: 'board',
    component: BoardView
  }, {
    path: '*',
    name: '404',
    component: NotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
